module.exports = __webpack_public_path__ + "img/anzhuang.942bb302.svg";